const p=["none","0px 1px 8px rgba(0,0,0, 0.0983937937062937), 0px 2px 2px rgba(0,0,0, 0.05673623251748252), 0px 0px 1px rgba(0,0,0, 0.15)",...Array(23).fill("0px 2px 10px 2px rgba(0,0,0, 0.09230222902097907), 0px 0px 1px rgba(0,0,0, 0.15)")];export{p as default};
//# sourceMappingURL=shadows.js.map
